import { render, staticRenderFns } from "./simpleList.vue?vue&type=template&id=3da76294&"
import script from "./simpleList.vue?vue&type=script&lang=js&"
export * from "./simpleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports